import { render, staticRenderFns } from "./terlibat_dilingkungan.vue?vue&type=template&id=2c3e8d78"
import script from "./terlibat_dilingkungan.vue?vue&type=script&lang=js"
export * from "./terlibat_dilingkungan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports